import angular from 'angular';
import postSettlementAddressModal from './postSettlementAddressModal';

export default angular
  .module('components.postSettlementAddressModal', [])
  .component('postSettlementAddressModal', postSettlementAddressModal).name;
